import React, { useMemo } from 'react';
import { renderSocialPostStatus, renderStatusColor } from './shared';
import { SocialPost } from '@core/models';
import { Divider, Tag } from 'antd';
import SocialPostImage from './SocialPostImage';
import { formatUtcDate } from '@utils/date.util';

type Props = {
  socialPost: SocialPost;
  locationId: string;
};

const SocialPostCardContent = ({ socialPost, locationId }: Props) => {
  const status = useMemo(() => renderSocialPostStatus(socialPost), [socialPost]);
  return (
    <React.Fragment>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Tag color={renderStatusColor(status)}>{status}</Tag>
        {socialPost.publish_at && <span>{formatUtcDate(socialPost.publish_at)}</span>}
      </div>
      <Divider style={{ margin: '10px 0px' }} />
      <p style={{ marginBottom: 20 }}>{socialPost?.content}</p>
      {locationId && <SocialPostImage locationId={locationId} mediaId={socialPost?.mediaIds[0]} />}
    </React.Fragment>
  );
};

export default SocialPostCardContent;
